import { Link } from 'react-router-dom';

const footerLinks = [
  {
    title: '内容导航',
    links: [
      { name: '传奇故事', path: '/category/legend' },
      { name: '修炼体系', path: '/category/cultivation' },
      { name: '热血情缘', path: '/category/romance' },
      { name: '仙道秘法', path: '/category/secret-art' },
      { name: '角色图鉴', path: '/category/characters' },
    ],
  },
  {
    title: '关于我们',
    links: [
      { name: '品牌介绍', path: '/about' },
      { name: '口碑评价', path: '/about#reputation' },
      { name: '联系方式', path: '/about#contact' },
    ],
  },
  {
    title: '友情链接',
    links: [
      { name: '仙侠世界', path: '#', },
      { name: '修炼论坛', path: '#', },
      { name: '小说阅读', path: '#', },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
            <div>
              <Link to="/" className="inline-block">
                <span className="text-2xl font-heading font-bold text-accent-400">
                  大爱仙尊
                </span>
              </Link>
              <p className="mt-4 text-sm text-secondary-200 leading-relaxed">
                汇聚仙侠世界顶级修炼体系，以大爱之名踏上仙尊之路。探索传奇故事、修炼秘法与热血情缘。
              </p>
              <div className="flex items-center gap-3 mt-5">
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-accent-500 transition-colors" aria-label="微博">
                  <i className="ri-weibo-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-accent-500 transition-colors" aria-label="微信">
                  <i className="ri-wechat-line text-sm"></i>
                </a>
                <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-secondary-700 hover:bg-accent-500 transition-colors" aria-label="QQ">
                  <i className="ri-qq-line text-sm"></i>
                </a>
              </div>
            </div>

            {footerLinks.map((group) => (
              <div key={group.title}>
                <h4 className="text-sm font-semibold text-background-50 mb-4">
                  {group.title}
                </h4>
                <ul className="space-y-3">
                  {group.links.map((link) => (
                    <li key={link.name}>
                      <Link
                        to={link.path}
                        className="text-sm text-secondary-200 hover:text-accent-400 transition-colors"
                      >
                        {link.name}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <div className="mt-14 pt-8 border-t border-secondary-700/50 flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-xs text-secondary-300">
              &copy; 2026 大爱仙尊. 版权所有.
            </p>
            <div className="flex items-center gap-6">
              <a href="#" className="text-xs text-secondary-300 hover:text-accent-400 transition-colors">隐私政策</a>
              <a href="#" className="text-xs text-secondary-300 hover:text-accent-400 transition-colors">用户协议</a>
              <a href="#" className="text-xs text-secondary-300 hover:text-accent-400 transition-colors">免责声明</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}